var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeDasharray: "4 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3906 26.3627V27.9832L17.9988 27.6666C17.9382 27.6177 16.4977 26.4481 15.0369 24.771C13.0217 22.4574 12 20.3806 12 18.5985V18.4219C12 14.8981 14.8668 12.0312 18.3906 12.0312C21.9144 12.0312 24.7812 14.8981 24.7812 18.4219V18.5985C24.7812 18.7482 24.7733 18.9001 24.7589 19.054L23.5092 17.9138C23.2532 15.3152 21.0554 13.2782 18.3906 13.2782C15.5544 13.2782 13.2469 15.5857 13.2469 18.4219V18.5985C13.2469 21.61 17.1271 25.2556 18.3906 26.3627ZM22.225 25.467H24.0953V23.5967H22.225V25.467ZM18.3906 15.7721C19.8517 15.7721 21.0404 16.9608 21.0404 18.4219C21.0404 19.8829 19.8517 21.0717 18.3906 21.0717C16.9296 21.0717 15.7408 19.8829 15.7408 18.4219C15.7408 16.9608 16.9296 15.7721 18.3906 15.7721ZM18.3906 17.019C17.6171 17.019 16.9878 17.6483 16.9878 18.4219C16.9878 19.1953 17.6171 19.8247 18.3906 19.8247C19.1641 19.8247 19.7935 19.1953 19.7935 18.4219C19.7935 17.6483 19.1641 17.019 18.3906 17.019ZM27.1597 24.6198L26.8091 24.2999V26.3018C26.8091 27.2339 26.0507 27.9922 25.1185 27.9922H21.1707C20.2385 27.9922 19.4801 27.2339 19.4801 26.3018V24.2999L19.1295 24.6198L18.2892 23.6986L23.1445 19.269L28 23.6986L27.1597 24.6198ZM25.5621 23.1624L23.1445 20.9569L20.7271 23.1624V26.3016C20.7271 26.5463 20.926 26.7452 21.1707 26.7452H25.1185C25.3632 26.7452 25.5621 26.5463 25.5621 26.3016V23.1624Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.35f7e2ad382a66b68d4f72ef6c76a634.svg";
export { ForwardRef as ReactComponent };